<template>
  <div v-if="goodsInfo">
    <goods-sku-info
      :skuInfo="goodsInfo.skuInfo"
      :showInfo="showInfo"
      :showImage="showImage"
      :imageSize="imageSize"
    >
      <template slot="info-append">
        <div v-if="showConsume" class="goods-consume">
          <div v-if="goodsInfo.storeInfo">
            <span> 所属门店: </span>
            <span style="color: #333333">
              {{ goodsInfo.storeInfo.name }}
            </span>
          </div>
          <div v-if="goodsInfo.lastValidTime > 0">
            <span> 有效日期: </span>
            <span style="color: #333333">
              {{ new Date(goodsInfo.lastValidTime).format("YYYY-MM-dd") || "" }}
            </span>
          </div>
          <div v-if="goodsInfo.costPrice > 0">
            <span> 成本单价: </span>
            <span style="color: #333333">
              {{ goodsInfo.costPrice }}
            </span>
            <span>元/份</span>
          </div>
          <div v-if="goodsInfo.shelfList">
            <span> 货位编号: </span>
            <span style="color: #333333">
              {{ goodsInfo.shelfList }}
            </span>
          </div>
          <div>
            <span> 库存数量: </span>
            <span style="color: #333333">
              {{ goodsInfo.fullStockCount }}
            </span>
            <span>
              {{ `${(goodsInfo.skuInfo && goodsInfo.skuInfo.goodsUnit) || "件"}` }}
            </span>
          </div>
          <div>
            <span> 可用库存: </span>
            <span style="color: #333333">
              {{ goodsInfo.stockCount || 0 }}
            </span>
            <span>
              {{ `${(goodsInfo.skuInfo && goodsInfo.skuInfo.goodsUnit) || "件"}` }}
            </span>
          </div>
          <!-- <div style="margin-top: 5px">
            <span style="margin-right: 5px">
              7日消耗
              <span>
                {{ goodsInfo.consume7dayCount || 0 }}
              </span>
              {{ (goodsInfo.skuInfo && goodsInfo.skuInfo.goodsUnit) || "件" }}
            </span>
            <span style="margin-right: 5px">
              30日消耗
              <span>
                {{ goodsInfo.consume30dayCount || 0 }}
              </span>
              {{ (goodsInfo.skuInfo && goodsInfo.skuInfo.goodsUnit) || "件" }}
            </span>
            <span style="margin-right: 5px">
              150日消耗
              <span>
                {{ goodsInfo.consume150dayCount || 0 }}
              </span>
              {{ (goodsInfo.skuInfo && goodsInfo.skuInfo.goodsUnit) || "件" }}
            </span>
          </div>
          <div style="color: #919191; font-size: 14px">
            <span> 周转: </span>
            <template v-if="goodsInfo.consume7dayCount > 0">
              <span>
                {{
                  ((7 * +goodsInfo.fullStockCount) / +goodsInfo.consume7dayCount).toFixed(
                    2
                  )
                }}
                天
              </span>
            </template>
            <template v-else>
              <span>无数据</span>
            </template>
          </div> -->
          <!-- <div v-if="goodsInfo.optSaleAbnormal == 1">
            <span
              style="color: #ff0000"
              v-if="goodsInfo.optSaleStatus == 1 && goodsInfo.fullStockCount <= 0"
            >
              商品已售罄，请下架
            </span>
            <span
              style="color: #ff0000"
              v-if="goodsInfo.optSaleStatus == 0 && goodsInfo.fullStockCount > 0"
            >
              商品有库存，请上架
            </span>
          </div> -->
        </div>
        <slot name="info-append" />
      </template>
    </goods-sku-info>
  </div>
</template>

<style lang="less" scoped>
.goods-consume {
  color: #919191;
  font-size: 14px;
  padding: 5px 0px;
}
</style>

<script>
import goodsSkuInfo from "./goodsSkuInfo.vue";
export default {
  components: { goodsSkuInfo },
  props: {
    showInfo: {
      type: Boolean,
      default: true,
    },
    showImage: {
      type: Boolean,
      default: true,
    },
    goodsInfo: {
      type: Object,
    },
    imageSize: {
      type: Number,
      default: 60,
    },
    showConsume: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
